import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import EditConfirmationModal from '../../components/common/EditConfirmationModal';
import TitleWithBack from '../../components/common/TitleWithBack';

function ExamTypesEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [typeName, setTypeName] = useState('');
  const [requiredDocuments, setRequiredDocuments] = useState('');
  const [tooltip, setTooltip] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    axios.get(`/api/exam-types/${id}`)
      .then(response => {
        const data = response.data;
        setTypeName(data.name);
        setRequiredDocuments(data.requiredDocuments.join(', '));
      })
      .catch(() => setTooltip('Error fetching exam type details.'));
  }, [id]);

  const updateExamType = () => {
    const docsArray = requiredDocuments
      .split(',')
      .map(doc => doc.trim())
      .filter(doc => doc);
    const payload = { name: typeName, requiredDocuments: docsArray };
    axios.put(`/api/exam-types/${id}`, payload)
      .then(() => {
        setTooltip('Exam type updated successfully!');
        setTimeout(() => navigate('/admin/exam-types/view'), 2000);
      })
      .catch(() => setTooltip('Error updating exam type.'));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Exam Type" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Exam Type Name</label>
              <input 
                type="text" 
                className="form-control"
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Required Documents (comma separated)</label>
              <textarea 
                className="form-control"
                value={requiredDocuments}
                onChange={(e) => setRequiredDocuments(e.target.value)}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Update Exam Type</button>
          </form>
          {tooltip && (
            <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
              {tooltip}
            </div>
          )}
        </div>
      </div>
      {showConfirm && (
        <EditConfirmationModal 
          title="Confirm Update"
          message="Are you sure you want to update this exam type?"
          onConfirm={() => { setShowConfirm(false); updateExamType(); }}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default ExamTypesEdit;
